var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"pa-5"},[_vm._v(" What are you doin here? ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }